export const defaultB = '#FFFFFF'
export const primaryB = '#0B6EC7'
export const secondaryB = '#E9F2FF'
export const positiveB = '#EDFFF6'
export const negativeB = '#FFE9E9'

export const defaultC = '#94A1B4'
export const primaryC = '#FFFFFF'
export const secondaryC = '#0B6EC7'
export const positiveC = '#4BAB43'
export const negativeC = '#FF4848'

export const darkBlue = '#1E385B'
export const yellow = '#F7D117'
export const lightBlue = '#DCEBFF'
